// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  ApiUrl: "https://project-hours.it/Api",
  logLevel: NgxLoggerLevel.INFO,
  serverLogLevel: NgxLoggerLevel.ERROR,
  demoMode: false,
  timeBetweenNotifications: 1 * 30 * 60 * 1000,

  firebaseConfig: {
    apiKey: "AIzaSyAygUx5tzCxIz9YRjANsAmehsKZ6_MTnXk",
    authDomain: "gestionenotifiche-d7962.firebaseapp.com",
    projectId: "gestionenotifiche-d7962",
    storageBucket: "gestionenotifiche-d7962.firebasestorage.app",
    messagingSenderId: "767049357971",
    appId: "1:767049357971:web:de025b38e43cae3c12cb66",
    measurementId: "G-1EBRS6HPQJ",
    vapidKey: "BHcWe652fEGds66uGZob9OnMIflTmWhIvbeiFlLcMHNiFo1y102w89PMr14p7kOhUnobbrE_r-fYatsxjiB7K18"
  }
};
